import React, { useState } from "react";

export default function AboutMe({ currentUser }) {
  const maxLength = 600; // Maximum length before truncation

  const [showFullText, setShowFullText] = useState(false);

  const toggleTextVisibility = () => {
    setShowFullText(!showFullText);
  };

  const aboutMeText = currentUser.details.About_Me__c;
  const truncatedText = aboutMeText.substring(0, maxLength) + "...";
  const shouldTruncate = aboutMeText.length > maxLength;

  return (
    <div className="py-8" id="About%20Me">
      <div id="About" className="container mx-auto px-4">
        <div className="text-md text-left">
          {showFullText || !shouldTruncate ? (
            <span dangerouslySetInnerHTML={{ __html: aboutMeText }} />
          ) : (
            <>
              <span dangerouslySetInnerHTML={{ __html: truncatedText }} />
            </>
          )}
        </div>
        <div className="cursor-pointer text-right text-blue-primary flex flex-row justify-end font-[600]">
          <p
            className="plus-icon flex items-center"
            onClick={toggleTextVisibility}
          >
            <span>{showFullText || !shouldTruncate ? "-" : "+"}</span>
            {showFullText || !shouldTruncate
              ? "Read Less"
              : "Read Complete Story"}
          </p>
        </div>
      </div>
    </div>
  );
}
